<div class="flex flex-col column-filter-dialog">
 <mat-icon svgIcon="close" class="cursor-pointer close-icon" (click)="closeSideNav()"></mat-icon>
  <div class="flex flex-row justify-between pb-10">
    <div class="flex flex-row">
      <div class="flex flex-col">
        <div class="mat-headline-5 mb-6 fw-600">{{ title }}</div>
        <div class="mat-body-1 fw-500">{{ subtitle }}</div>
      </div>
    </div>
    <span class="reset-text fs-16 fw-500" *ngIf="hasAnySelection()" (click)="resetFilterColumn()">{{'BUTTONS.RESET' | transloco}}</span>
  </div>
  <mat-divider class="mb-20 divider"></mat-divider>
<ng-container *ngIf="name === 'Audit Dashboard'">

  <div class="filter-group">
  <label class="fs-16 fw-600 filter-label-align">{{'INSTANCE_DETAILS.INITIATED_BY' | transloco }}</label>
    <mat-select #userSelect [value]="tempSelectedUser" (closed)="onUserDropdownClosed()" class="fw-500 form-select fs-16 add-route" placeholder="Select User" multiple (openedChange)="onUserDropdownOpen($event)">
      <mat-select-trigger>
       <ng-container *ngIf="selectedUser?.length > 0; else noSelection">
          <span [ngClass]="'value-text'">
            {{ selectedUser.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
          </span>
        </ng-container>
        <ng-template #noSelection >
          <span [ngClass]="'placeholder-text'">{{'INSTANCE_DETAILS.SELECT_USER' | transloco }}</span>
        </ng-template>
    </mat-select-trigger>
    <div class="dropdown-panel">
<div class="pt-2 pb-0">
  <div class="search-wrapper">
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
     <input [(ngModel)]="searchUserValue" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchUserChanged($event)" type="text" class="fw-500 search-input" placeholder="Search"
        (keydown)="$event.stopPropagation()"/>
  </div>
</div>

<div class="panel-info">{{'INSTANCE_DETAILS.SHOWING_RESULTS' | transloco: {count: filteredUser?.length} }}</div>
   <div class="panel-list">
  <mat-option *ngFor="let user of filteredUser" [value]="user.value" (onSelectionChange)="onUserOptionSelection($event, user.value)">
    {{ user.value }}
  </mat-option>
  </div>
  <mat-divider></mat-divider>
  <div class="panel-footer">
    <button mat-button class="warn-solid fs-16 fw-500" [disabled]="!filteredUser?.length" (click)="clearAllUser($event, userSelect)">{{'BUTTONS.CLEAR_ALL' | transloco }}</button>
    <div class="footer-actions">
      <button class="apply-cancel" (click)="closeUserDropdown(userSelect)">{{'BUTTONS.CANCEL' | transloco }}</button>
      <button class="apply-cancel white" [disabled]="!filteredUser?.length" (click)="applyUserSelection(userSelect)">{{'BUTTONS.APPLY' | transloco }}</button>
    </div>
  </div>
  </div> 
</mat-select>
    </div>
    <div class="filter-group">
    <label class="fs-16 fw-600 filter-label-align">{{'INSTANCE_DETAILS.ACTION' | transloco }}</label>
    <mat-select #actionSelect [value]="tempSelectedAction" (closed)="onActionDropdownClosed()" class="fw-500 form-select fs-16 add-route" placeholder="Select Action" multiple (openedChange)="onActionDropdownOpen($event)">
    <mat-select-trigger>
       <ng-container *ngIf="selectedAction?.length > 0; else noActionSelection">
          <span [ngClass]="'value-text'">
            {{ selectedAction.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
          </span>
        </ng-container>
        <ng-template #noActionSelection >
          <span [ngClass]="'placeholder-text'">{{'INSTANCE_DETAILS.SELECT_ACTION' | transloco }}</span>
        </ng-template>
    </mat-select-trigger>
    <div class="dropdown-panel">
<div class="pt-2 pb-0">
  <div class="search-wrapper">
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
     <input [(ngModel)]="searchActionValue" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchActionChanged($event)" type="text" class="fw-500 search-input" placeholder="Search"
        (keydown)="$event.stopPropagation()"/>
  </div>
</div> 
<div class="panel-info">{{'INSTANCE_DETAILS.SHOWING_RESULTS' | transloco: {count: filteredActions?.length} }}</div>
   <div class="panel-list">
  <mat-option *ngFor="let action of filteredActions" [value]="action.value" (onSelectionChange)="onActionOptionSelection($event, action.value)">
    {{ action.value }}
  </mat-option>
  </div>
  <mat-divider></mat-divider>
  <div class="panel-footer">
    <button mat-button class="warn-solid fs-16 fw-500" [disabled]="!filteredActions?.length" (click)="clearAllActions($event, actionSelect)">{{'BUTTONS.CLEAR_ALL' | transloco }}</button>
    <div class="footer-actions">
      <button class="apply-cancel" (click)="closeActionDropdown(actionSelect)">{{'BUTTONS.CANCEL' | transloco }}</button>
      <button class="apply-cancel white" [disabled]="!filteredActions?.length" (click)="applyActionSelection(actionSelect)">{{'BUTTONS.APPLY' | transloco }}</button>
    </div>
  </div>
  </div>
</mat-select>
</div>
<div class="filter-group">
    <label class="fs-16 fw-600 filter-label-align">{{'INSTANCE_STATUS.TENANT' | transloco }}</label>
    <mat-select #tenantSelect [value]="tempSelectedTenant" (closed)="onTenantDropdownClosed()" class="fw-500 form-select fs-16 add-route" placeholder="Select Tenant" multiple (openedChange)="onTenantDropdownOpen($event)">
    <mat-select-trigger>
       <ng-container *ngIf="selectedTenant?.length > 0; else noTenantSelection">
          <span [ngClass]="'value-text'">
            {{ selectedTenant.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
          </span>
        </ng-container>
        <ng-template #noTenantSelection >
          <span [ngClass]="'placeholder-text'">{{'INSTANCE_DETAILS.SELECT_TENANT' | transloco }}</span>
        </ng-template>
    </mat-select-trigger>
    <div class="dropdown-panel">
<div class="pt-2 pb-0">
  <div class="search-wrapper">
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
     <input [(ngModel)]="searchTenantValue" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchTenantChanged($event)" type="text" class="fw-500 search-input" placeholder="Search"
        (keydown)="$event.stopPropagation()"/>
  </div>
</div> 
<div class="panel-info">{{'INSTANCE_DETAILS.SHOWING_RESULTS' | transloco: {count: filteredTenant?.length } }}</div>
   <div class="panel-list">
  <mat-option *ngFor="let tenant of filteredTenant" [value]="tenant.value" (onSelectionChange)="onTenantOptionSelection($event, tenant.value)">
    {{ tenant.value }}
  </mat-option>
  </div>
  <mat-divider></mat-divider>
  <div class="panel-footer">
    <button mat-button class="warn-solid fs-16 fw-500" [disabled]="!filteredTenant?.length" (click)="clearAllTenant($event, tenantSelect)">{{'BUTTONS.CLEAR_ALL' | transloco }}</button>
    <div class="footer-actions">
      <button class="apply-cancel" (click)="closeTenantDropdown(tenantSelect)">{{'BUTTONS.CANCEL' | transloco }}</button>
      <button class="apply-cancel white" [disabled]="!filteredTenant?.length" (click)="applyTenantSelection(tenantSelect)">{{'BUTTONS.APPLY' | transloco }}</button>
    </div>
  </div>
  </div>
</mat-select>
</div>
<div class="filter-group">
    <label class="fs-16 fw-600 filter-label-align">{{'INSTANCE_DETAILS.STATUS' | transloco }}</label>
    <mat-select #statusSelect [value]="tempSelectedStatus" (closed)="onStatusDropdownClosed()" class="fw-500 form-select fs-16 add-route" placeholder="Select Status" multiple (openedChange)="onStatusDropdownOpen($event)">
    <mat-select-trigger>
       <ng-container *ngIf="selectedStatus?.length > 0; else noStatusSelection">
          <span [ngClass]="'value-text'">
            {{ selectedStatus.length }} {{ 'CREATE_SERVICE.SELECTED' | transloco }}
          </span>
        </ng-container>
        <ng-template #noStatusSelection >
          <span [ngClass]="'placeholder-text'">{{'INSTANCE_DETAILS.SELECT_STATUS' | transloco }}</span>
        </ng-template>
    </mat-select-trigger>
    <div class="dropdown-panel">
<div class="pt-2 pb-0">
  <div class="search-wrapper">
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
     <input [(ngModel)]="searchStatusValue" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchStatusChanged($event)" type="text" class="fw-500 search-input" placeholder="Search"
        (keydown)="$event.stopPropagation()"/>
  </div>
</div> 
<div class="panel-info">{{'INSTANCE_DETAILS.SHOWING_RESULTS' | transloco: {count: filteredStatus?.length } }}</div>
   <div class="panel-list">
  <mat-option *ngFor="let status of filteredStatus" [value]="status.value" (onSelectionChange)="onStatusOptionSelection($event, status.value)">
    {{ status.value }}
  </mat-option>
  </div>
  <mat-divider></mat-divider>
  <div class="panel-footer">
    <button mat-button class="warn-solid fs-16 fw-500" [disabled]="!filteredStatus?.length" (click)="clearAllStatus($event, statusSelect)">{{'BUTTONS.CLEAR_ALL' | transloco }}</button>
    <div class="footer-actions">
      <button class="apply-cancel" (click)="closeStatusDropdown(statusSelect)">{{'BUTTONS.CANCEL' | transloco }}</button>
      <button class="apply-cancel white" [disabled]="!filteredStatus?.length" (click)="applyStatusSelection(statusSelect)">{{'BUTTONS.APPLY' | transloco }}</button>
    </div>
  </div>
  </div>
</mat-select>
</div>
     <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [class.disabled]="!hasAnySelection()" type="button" (click)="applyFilter()">{{'BUTTONS.CONFIRM' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
</ng-container>
</div>